import { type UserProfile } from '../../api/schemas/user-profile.schema';

type UPDATE = 'UPDATE';
type CLEAR = 'CLEAR';

type UPDATE_ACTION = { type: UPDATE; payload: UserProfile };
type CLEAR_ACTION = { type: CLEAR };

export type UserReducerAction = UPDATE_ACTION | CLEAR_ACTION;

function userReducer(user: UserProfile | undefined, action: UserReducerAction) {
  switch (action.type) {
    case 'UPDATE':
      return { ...user, ...action.payload };
    case 'CLEAR':
      return undefined;
    default:
      return user;
  }
}

export { userReducer };
